import Skeleton from 'react-loading-skeleton';
import { emptyArray } from 'src/utils/helpers';
import './style.scss';

interface IProps<T> {
  data?: T[];
  leading?: (item: T) => JSX.Element;
  trailing: (item: T) => JSX.Element;
  loading?: boolean;
  notFull: boolean;
}

const TimeLine = <T,>(props: IProps<T>): JSX.Element => {
  const renderItem = (item: T, index: number) => {
    if (!props.data) return;

    const isLast = index === props.data.length - 1;
    return (
      <div className="time-line">
        {props.leading ? <div className="time-line__leading">{props.leading(item)}</div> : null}
        <div className="time-line__line-container mr-6">
          <div className="time-line__line-container-circle" />
          {isLast && !props.notFull ? null : <div className={`time-line__line-container-line ${isLast ? 'last' : ''}`} />}
        </div>
        <div className="time-line__trailing">{props.trailing(item)}</div>
      </div>
    );
  };

  return (
    <div className="d-flex flex-column flex-1">
      {props.loading || !props.data ? (
        <div className="d-flex flex-1 flex-row full-width">
          {props.leading ? (
            <div className="d-flex flex-column justify-content-between mr-6">
              {[emptyArray(4)].map(() => (
                <Skeleton width={75} height={35} style={{ borderRadius: 12 }} />
              ))}
            </div>
          ) : null}
          <Skeleton width={25} height={200} style={{ borderRadius: 12 }} />
          <div className="d-flex flex-column justify-content-between full-width ml-6">
            {[emptyArray(4)].map(() => (
              <Skeleton
                // @ts-ignore
                wrapper={({ children }: any) => <span className="full-width">{children}</span>}
                height={35}
                style={{ borderRadius: 12 }}
              />
            ))}
          </div>
        </div>
      ) : (
        <>
          {props.data.map((item, index) => renderItem(item, index))}
          {props.notFull ? (
            <div className="time-line">
              {props.leading ? <div className="time-line__leading" /> : null}
              <div className="time-line__line-container mr-6">
                <div className="time-line__line-container-circle last" />
              </div>
              <div className="time-line__trailing" />
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

export default TimeLine;
